import { createRequest } from "@/common/helpers/RequestHelpers";
import { NotificationManager } from "react-notifications";
import { v4 as uuidv4 } from "uuid";

const Types = {
	REPORT_SHOW_PAYPERIOD_MODAL: "REPORT_SHOW_PAYPERIOD_MODAL",
	REPORT_FILTERS: "REPORT_FILTERS",
	REPORT_SAVE_PACKS: "REPORT_SAVE_PACKS",
	REPORT_SAVE_CUSTOM: "REPORTS_SAVE_CUSTOM",
	REPORT_SAVE_FAVOURITE: "REPORT_SAVE_FAVOURITE",
};

const LOCAL = false;

const request = createRequest({ urlPath: "/settings/", local: LOCAL });

const showReportPayPeriodModal = (show) => ({
	type: Types.REPORT_SHOW_PAYPERIOD_MODAL,
	show,
});
const updateReportFilters = (options) => ({
	type: Types.REPORT_FILTERS,
	options,
});

const saveReportPacks = (data) => ({
	type: Types.REPORT_SAVE_PACKS,
	data,
});

const saveCustomReports = (data) => ({
	type: Types.REPORT_SAVE_CUSTOM,
	data,
});

const saveFavouritedReports = (data) => ({
	type: Types.REPORT_SAVE_FAVOURITE,
	data,
});

const getReportData = ({ setProcessing, report, params }) => {
	return async (dispatch, getState) => {
		request({
			method: "GET",
			path: report.path ? report.path : `report/get/${report.id}`,
			query: params,
		}).then(({ data }) => {
			const popup = window.open(data.signedURL);
			if (!popup || popup.closed || typeof popup.closed == "undefined") {
				//Worked For IE and Firefox
				alert("Popup Blocker is enabled! Please add this site to your exception list.");
			}
			setProcessing(false);
		});
	};
};

const postReportPacks = (reportPacks) => {
	return async (dispatch, getState) => {
		request({
			method: "POST",
			path: "report/reportPacks",
			body: { reportPacks },
		})
			.then(({ data }) => {
				dispatch(saveReportPacks(data.reportPacks));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Saving Report Packs", "Report Packs");
			});
	};
};

const getReportPacks = () => {
	return async (dispatch, getState) => {
		request({
			method: "GET",
			path: "report/reportPacks",
		})
			.then(({ data }) => {
				dispatch(saveReportPacks(data));
			})
			.catch((error) => {
				console.error(error);
			});
	};
};

const getCustomReports = () => {
	return async (dispatch, getState) => {
		request({
			method: "GET",
			path: "report/customReports",
		})
			.then(({ data }) => {
				dispatch(saveCustomReports(data));
			})
			.catch((error) => {
				console.error(error);
			});
	};
};

const postCustomReports = (customReports) => {
	return async (dispatch, getState) => {
		request({
			method: "POST",
			path: "report/customReports",
			body: { customReports },
		})
			.then(({ data }) => {
				dispatch(saveCustomReports(data.customReports));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Saving Custom Reports", "Custom Reports");
			});
	};
};

const getFavouritedReports = () => {
	return async (dispatch, getState) => {
		request({
			method: "GET",
			path: "report/favouritedReports",
		})
			.then(({ data }) => {
				dispatch(saveFavouritedReports(data));
			})
			.catch((error) => {
				console.error(error);
			});
	};
};

const postFavouritedReports = (favouritedReports) => {
	return async (dispatch, getState) => {
		request({
			method: "POST",
			path: "report/favouritedReports",
			body: { favouritedReports },
		})
			.then(({ data }) => {
				dispatch(saveFavouritedReports(data.favouritedReports));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Saving Favourited Reports", "Favourited Reports");
			});
	};
};

const duplicateReport = ({data, navigate}) => {
	return async (dispatch, getState) => {

		const newReport = { ...data };
		newReport.id = uuidv4();
		newReport.name = `${newReport.name} - Copy`;

		request({
			method: "POST",
			path: "report/template",
			body: newReport
		})
			.then(({data}) => {
				console.log('result',data)
				navigate(`/advisor/reports/customReports/${newReport.id}`);
			})
			.catch((error) => {
				console.error(error);
			});

	}
}


const Actions = {
	showReportPayPeriodModal,
	updateReportFilters,
	getReportData,
	saveReportPacks,
	saveCustomReports,
	saveFavouritedReports,
	postReportPacks,
	getReportPacks,
	getCustomReports,
	postCustomReports,
	getFavouritedReports,
	postFavouritedReports,
	duplicateReport,
};

export { Types, Actions };
